{
  "it-IT": {
    "model": {
      "profile": {
        "id": "ID utente",
        "userName": "Nome utente",
        "email": "Indirizzo e-mail",
        "emailConfirmed": "Email confermata",
        "phoneNumber": "Numero di telefono",
        "phoneNumberConfirmed": "Numero di telefono verificato.",
        "twoFactorEnabled": "Autenticazione a due fattori abilitata.",
        "lockoutEnd": "Data di scadenza del blocco",
        "lockoutEnabled": "Blocco attivo",
        "accessFailedCount": "Numero di tentativi di accesso falliti",
        "firstName": "Nome",
        "lastName": "Cognome",
        "picture": "Immagine del profilo.",
        "organisationName": "Organizzazione",
        "name": "Nome",
        "roles": "Ruoli"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confermato"
      },
      "action": {
        "resetPassword.tooltip": "Invia all'utente le istruzioni per il ripristino della password tramite e-mail."
      },
      "message": {
        "resetPassword.success": "È stata inviata un’e-mail all’utente contenente le istruzioni per reimpostare la password."
      }
    }
  }
}